import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function RefListEditor({ rows, onChange, choices, idKey, placeholder, testId, unitOf }) {
  const upd = (i, patch) => onChange(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  return (
    <div className="space-y-2" data-testid={testId}>
      {rows.map((r, i) => (
        <div key={i} className="flex gap-2">
          <select value={r[idKey]} onChange={(e) => upd(i, { [idKey]: e.target.value })} className="h-10 flex-1 min-w-0 rounded-md border bg-transparent px-2 text-sm" data-testid={`${testId}-select-${i}`}>
            <option value="">{placeholder}</option>
            {choices.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <Input type="number" step="0.001" min="0" value={r.qty} onChange={(e) => upd(i, { qty: e.target.value })} className="w-24" data-testid={`${testId}-qty-${i}`} />
          <span className="w-8 self-center text-xs text-muted-foreground">{unitOf ? unitOf(r[idKey]) : "un"}</span>
          <Button type="button" size="icon" variant="ghost" onClick={() => onChange(rows.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" onClick={() => onChange([...rows, { [idKey]: "", qty: 1 }])} data-testid={`${testId}-add-btn`}><Plus className="h-4 w-4 mr-1" />Adicionar</Button>
    </div>
  );
}
